import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PesvViasInspeccionesPayload {
  via_id: number;
  zona_id?: number | null;
  riesgo_id?: number | null;
  codigo: string;
  tipo_inspeccion: number;
  motivo?: number | null;
  fecha_inspeccion: string;
  inspector_id?: number | null;
  condiciones_climaticas?: number | null;
  condiciones_operacion?: number | null;
  resultado?: number | null;
  observaciones?: string | null;
  estado?: number;
  created_by?: number | null;
  updated_by?: number | null;
}

/**
 * 🔹 Entidad
 */
export interface PesvViasInspecciones {
  id?: number;
  via_id: number;
  zona_id?: number | null;
  riesgo_id?: number | null;
  codigo: string;
  tipo_inspeccion: number;
  motivo?: number | null;
  fecha_inspeccion: string;
  inspector_id?: number | null;
  condiciones_climaticas?: number | null;
  condiciones_operacion?: number | null;
  resultado?: number | null;
  observaciones?: string | null;
  estado: number;
  created_by?: number | null;
  updated_by?: number | null;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface PesvViasInspeccionesResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PesvViasInspeccionesService {
  private readonly apiUrl = `${environment.apiUrl}/api/pesv_vias_inspecciones`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todas las inspecciones
   */
  getAll(): Observable<PesvViasInspecciones[]> {
    return this.http.get<PesvViasInspecciones[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener inspección por ID
   */
  getById(id: number): Observable<PesvViasInspecciones> {
    return this.http.get<PesvViasInspecciones>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear inspección
   */
  create(
    payload: PesvViasInspeccionesPayload
  ): Observable<PesvViasInspeccionesResponse> {
    return this.http.post<PesvViasInspeccionesResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar inspección
   */
  update(
    id: number,
    payload: Partial<PesvViasInspeccionesPayload>
  ): Observable<PesvViasInspeccionesResponse> {
    return this.http.put<PesvViasInspeccionesResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar inspección
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar inspección
   */
  inactivar(id: number): Observable<PesvViasInspeccionesResponse> {
    return this.http.put<PesvViasInspeccionesResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar inspección
   */
  activar(id: number): Observable<PesvViasInspeccionesResponse> {
    return this.http.put<PesvViasInspeccionesResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
  
  getInspeccionZona(zonaId: number): Observable<PesvViasInspecciones[]> {
    return this.http.get<PesvViasInspecciones[]>(
      `${this.apiUrl}/zona/${zonaId}`,
      {
        withCredentials: true,
      }
    );
  }
}